angular.module('rightPaneModule')
.controller('StudentUsageController', ['$scope', 'studentApi', 'reportErrors', function($scope, $studentApi, $reportErrors) {

  $scope.years = { list: null, selected: {} };
  $scope.timeframes = {
    list: [
      { id: '7d', name: 'Last 7 Days', by: 'day', active: true },
      { id: '30d', name: 'Last 30 Days', by: 'week', active: false }
    ],
    selected: {}
  };

  var updateUsageData = function() {
    $scope.studentUsageUrl = $studentApi.getStudentUsageExportUrl();
    $scope.usageError = null;
    $scope.usageData = undefined;
    $studentApi.getStudentUsage().then(function(usageData) {
      $scope.usageData = usageData;
    }, function(error) {
      $scope.usageError = $reportErrors.getErrorMessage(error);
    });
  };

  var initializeData = function(e, item) {
    $scope.item = item;
  };

  $scope.$on('updateYears', function(e, years) {
    $scope.years.list = angular.copy(years);
  });

  $scope.$on('itemReady', initializeData);
  $scope.$on('timeframeSelected', updateUsageData);
  $scope.$on('timeframeInitialized', updateUsageData);

}]);
